module.exports = __webpack_public_path__ + "img/frame (159).c4ca169f.jpg";